var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGrid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 2.5H5.5V4.5H3.5V2.5Z",
    fill: "#BAE0BD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 3V4H4V3H5ZM5.5 2H3.5C3.224 2 3 2.224 3 2.5V4.5C3 4.776 3.224 5 3.5 5H5.5C5.776 5 6 4.776 6 4.5V2.5C6 2.224 5.776 2 5.5 2Z",
    fill: "#5E9C76"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 2.5H9.5V4.5H7.5V2.5Z",
    fill: "#BAE0BD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9 3V4H8V3H9ZM9.5 2H7.5C7.224 2 7 2.224 7 2.5V4.5C7 4.776 7.224 5 7.5 5H9.5C9.776 5 10 4.776 10 4.5V2.5C10 2.224 9.776 2 9.5 2Z",
    fill: "#5E9C76"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 2.5H13.5V4.5H11.5V2.5Z",
    fill: "#BAE0BD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13 3V4H12V3H13ZM13.5 2H11.5C11.224 2 11 2.224 11 2.5V4.5C11 4.776 11.224 5 11.5 5H13.5C13.776 5 14 4.776 14 4.5V2.5C14 2.224 13.776 2 13.5 2Z",
    fill: "#5E9C76"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 6.5H5.5V8.5H3.5V6.5Z",
    fill: "#BAE0BD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5 7V8H4V7H5ZM5.5 6H3.5C3.224 6 3 6.224 3 6.5V8.5C3 8.776 3.224 9 3.5 9H5.5C5.776 9 6 8.776 6 8.5V6.5C6 6.224 5.776 6 5.5 6Z",
    fill: "#5E9C76"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 6.5H9.5V8.5H7.5V6.5Z",
    fill: "#BAE0BD"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9 7V8H8V7H9ZM9.5 6H7.5C7.224 6 7 6.224 7 6.5V8.5C7 8.776 7.224 9 7.5 9H9.5C9.776 9 10 8.776 10 8.5V6.5C10 6.224 9.776 6 9.5 6Z",
    fill: "#5E9C76"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 6.5H13.5V8.5H11.5V6.5Z",
    fill: "#BAE0BD"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M13 7V8H12V7H13ZM13.5 6H11.5C11.224 6 11 6.224 11 6.5V8.5C11 8.776 11.224 9 11.5 9H13.5C13.776 9 14 8.776 14 8.5V6.5C14 6.224 13.776 6 13.5 6Z",
    fill: "#5E9C76"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 10.5H5.5V12.5H3.5V10.5Z",
    fill: "#BAE0BD"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M5 11V12H4V11H5ZM5.5 10H3.5C3.224 10 3 10.224 3 10.5V12.5C3 12.776 3.224 13 3.5 13H5.5C5.776 13 6 12.776 6 12.5V10.5C6 10.224 5.776 10 5.5 10Z",
    fill: "#5E9C76"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 10.5H9.5V12.5H7.5V10.5Z",
    fill: "#BAE0BD"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M9 11V12H8V11H9ZM9.5 10H7.5C7.224 10 7 10.224 7 10.5V12.5C7 12.776 7.224 13 7.5 13H9.5C9.776 13 10 12.776 10 12.5V10.5C10 10.224 9.776 10 9.5 10Z",
    fill: "#5E9C76"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 10.5H13.5V12.5H11.5V10.5Z",
    fill: "#BAE0BD"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M13 11V12H12V11H13ZM13.5 10H11.5C11.224 10 11 10.224 11 10.5V12.5C11 12.776 11.224 13 11.5 13H13.5C13.776 13 14 12.776 14 12.5V10.5C14 10.224 13.776 10 13.5 10Z",
    fill: "#5E9C76"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid);
export default __webpack_public_path__ + "static/media/grid.320b856c621b2299b56ad938e5ecd536.svg";
export { ForwardRef as ReactComponent };